<template>
  <div class="Control">
    <div class="Control__title">{{ title }}</div>
    <div class="Control__body">
      <div class="Control__half">
        <div :class="buttonClasses">−</div>
      </div>
      <div class="Control__half">
        <div :class="buttonClasses">+</div>
      </div>
      <div class="Control__value">
        {{ humanValue }}
      </div>
      <div class="Control__tap" @click="less" />
      <div class="Control__tap" @click="more" />
    </div>
  </div>
</template>

<script>
import EventBus from '@/components/EventBus.js';

export default {
  name: 'IO',
  props: {
    title: String,
    color: String,
    value: Number,
    code: String,
    min: Number,
    max: Number,
    gap: Number,
    mult: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      clicked: false
    }
  },
  computed: {
    buttonClasses() {
      return [
        'Control__button',
        `Control__button_color_${this.color}`
      ]
    },
    humanValue() {
      return Math.round(this.value * this.mult);
    }
  },
  methods: {
    less() {
      let v = this.value - this.gap;
      v = Math.max(v, this.min);
      v = Math.min(v, this.max);
      EventBus.$emit('control-change', { code: this.code, value: v })
    },
    more() {
      let v = this.value + this.gap;
      v = Math.max(v, this.min);
      v = Math.min(v, this.max);
      EventBus.$emit('control-change', { code: this.code, value: v })
    }
  }
}
</script>

<style lang="scss">
.Control {
  height: 72px;
  overflow: hidden;
  padding-top: 8px;
  box-sizing: border-box;

  &__title {
    text-align: center;
    font-size: 12px;
    line-height: 12px;
  }

  &__body {
    height: 32px;
    border-radius: 16px;
    box-sizing: border-box;
    display: flex;
    position: relative;
    margin-top: 4px;
  }

  &__half {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 0;
    position: relative;

    &:first-child:after {
      content: '';
      position: absolute;
      left: 50%;
      top: 0;
      right: 0;
      bottom: 0;
      background: black;
      z-index: 10;
    }
    &:nth-child(2):after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      right: 50%;
      bottom: 0;
      background: black;
      z-index: 10;
    }
  }

  &__button {
    width: 24px;
    height: 21px;
    border: 4px solid black;
    background: white;
    border-radius: 100%;
    text-align: center;
    font-size: 16px;
    line-height: 16px;
    padding-top: 3px;
    margin: 0 auto;
    position: relative;
    z-index: 20;

    &_color {
      &_orange {
        background: #FA6400;
      }

      &_green {
        background: #89CA73;
      }

      &_red {
        background: #DA4745;
      }

      &_yellow {
        background: #FBC805;
      }

      &_cyan {
        background: #96D0DC;
      }

      &_coral {
        background: #FA7E57;
      }

      &_violet {
        background: #B620E0;
      }

      &_blue {
        background: #1e88e5;
      }
    }
  }

  &__value {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    text-align: center;
    font-size: 12px;
    line-height: 12px;
    color: white;
    z-index: 30;
    padding-top: 10px;
  }

  &__tap {
    position: absolute;
    left: 0;
    right: 50%;
    top: 0;
    bottom: 0;
    z-index: 50;
    cursor: pointer;

    &:last-child {
      left: 50%;
      right: 0;
    }
  }
}
</style>
